import type { IconProps } from "@/types/icon";

const StepEmpty = ({ color = "#4D0FFF", className }: IconProps) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g filter="url(#filter0_dd_3368_8492)">
      <g clipPath="url(#clip0_3368_8492)">
        <rect x="4" y="4" width="24" height="24" rx="12" fill="#F1F0FF" />
        <rect
          x="4.75"
          y="4.75"
          width="22.5"
          height="22.5"
          rx="11.25"
          fill={color}
        />
        <rect
          x="4.75"
          y="4.75"
          width="22.5"
          height="22.5"
          rx="11.25"
          stroke={color}
          strokeWidth="1.5"
        />
        <circle cx="16" cy="16" r="4" fill="white" />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_dd_3368_8492"
        x="0"
        y="0"
        width="32"
        height="32"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="4"
          operator="dilate"
          in="SourceAlpha"
          result="effect1_dropShadow_3368_8492"
        />
        <feOffset />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.619608 0 0 0 0 0.466667 0 0 0 0 0.929412 0 0 0 0.24 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3368_8492"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_3368_8492"
          result="effect2_dropShadow_3368_8492"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_3368_8492"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_3368_8492">
        <rect x="4" y="4" width="24" height="24" rx="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default StepEmpty;
